import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API() + 'uzytk/'

export default {


    getRoleUzytkownikow() {
        return axios({
            method: 'get',
            url: URL + 'role',
        });
    },

    getUzytkowicy(page, size, szukanyCiag = '', szukanyTyp = null) {
        if (szukanyTyp) {
            console.log(page, size, szukanyCiag, szukanyTyp)
            return axios({
                method:'post',
                url: URL + `search?typ=${szukanyTyp.value}&login=${szukanyCiag}&page=${page}&size=${size}&sort=idUz,asc`,
            })
        } else {
            return axios({
                method: 'get',
                url: URL + `?page=${page}&size=${size}&sort=idUz,asc`,
            });
        }

    },

    getUzytkownik(userid) {
        return axios({
            method: 'get',
            url: URL + userid,
        });
    },

    addUzytkownik(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editUzytkownik(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteUzytkownik(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

    zmienHaslo(data) {
        return axios({
            method: 'post',
            url: URL + 'savePassword',
            data: JSON.stringify(data),
        })
    },

    zmienHasloUzytkowikowi(data) {
        return axios({
            method: 'post',
            url: URL + 'admin/savePassword',
            data: JSON.stringify(data),
        })
    }

}


// WEBPACK FOOTER //
// ./src/modules/administracja/dostep/DostepService.js